/**
 * Channels – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Channels / channel list. */
export default function ChannelsIcon({
  focused,
  width,
  height,
  margin,
  fromMenu = false,
  fromFloatingMenu = false,
}: Props & { fromMenu?: boolean; fromFloatingMenu?: boolean }) {
  const color = fromMenu
    ? Colors['menu']['icon'][focused ? 'focused' : 'unfocused']
    : Colors[focused ? 'dark' : 'light'];
  const defaultWidth = fromFloatingMenu
    ? 32 * Screen.widthRatio
    : 22 * Screen.widthRatio;
  const defaultHeight = fromFloatingMenu
    ? 30 * Screen.widthRatio
    : 20 * Screen.widthRatio;
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || defaultWidth}
      height={height || defaultHeight}
      viewBox='0 0 22 20'
      fill='none'
      style={{ margin: margin ?? 0 }}
    >
      <path
        d='M6.87842 17.6472C6.87842 16.9974 7.40514 16.4707 8.05489 16.4707H20.6039C21.2537 16.4707 21.7804 16.9974 21.7804 17.6472V18.8236C21.7804 19.4734 21.2537 20.0001 20.6039 20.0001H8.05489C7.40514 20.0001 6.87842 19.4734 6.87842 18.8236V17.6472Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M6.87842 9.41182C6.87842 8.76208 7.40514 8.23535 8.05489 8.23535H20.6039C21.2537 8.23535 21.7804 8.76208 21.7804 9.41182V10.5883C21.7804 11.238 21.2537 11.7648 20.6039 11.7648H8.05489C7.40514 11.7648 6.87842 11.238 6.87842 10.5883V9.41182Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M6.87842 1.17647C6.87842 0.526724 7.40514 0 8.05489 0H20.6039C21.2537 0 21.7804 0.526724 21.7804 1.17647V2.35294C21.7804 3.00269 21.2537 3.52941 20.6039 3.52941H8.05489C7.40514 3.52941 6.87842 3.00269 6.87842 2.35294V1.17647Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M0 1.37642C0 0.726675 0.526724 0.199951 1.17647 0.199951H3.62353C4.27328 0.199951 4.8 0.726675 4.8 1.37642V2.22348C4.8 2.87323 4.27328 3.39995 3.62353 3.39995H1.17647C0.526724 3.39995 0 2.87323 0 2.22348V1.37642Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M0 9.37642C0 8.72668 0.526724 8.19995 1.17647 8.19995H3.62353C4.27328 8.19995 4.8 8.72668 4.8 9.37642V10.6235C4.8 11.2732 4.27328 11.8 3.62353 11.8H1.17647C0.526724 11.8 0 11.2732 0 10.6235V9.37642Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M0 17.7766C0 17.1268 0.526724 16.6001 1.17647 16.6001H3.62353C4.27328 16.6001 4.8 17.1268 4.8 17.7766V18.6236C4.8 19.2734 4.27328 19.8001 3.62353 19.8001H1.17647C0.526724 19.8001 0 19.2734 0 18.6236V17.7766Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
}
